import { Colour } from 'components/variables'
import * as React from 'react'

import classNames from 'classnames'
import './Layout.scss'

interface LayoutProps {
  color?: Colour
  whiteBackground?: boolean
  children?: React.ReactNode | undefined
}

const Layout: React.FC<LayoutProps> = ({
  color = Colour.turquoise,
  whiteBackground,
  children,
}: LayoutProps) => {
  const className = classNames(
    `layout-${color}`,
    whiteBackground ? `use-white-background` : '',
  )

  return (
    <main className={className} role="main">
      {children}
    </main>
  )
}

export default Layout
